var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#4B286D",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035 2244 c-11 -2 -45 -9 -75 -15 -73 -14 -221 -87 -292 -144 -108 -85 -207 -241 -243 -380 -51 -197 -12 -462 102 -690 54 -106 141 -237 214 -318 28 -32 50 -59 48 -61 -2 -1 -47 -13 -99 -25 -117 -28 -204 -68 -250 -116 -50 -51 -50 -109 0 -160 99 -102 342 -159 680 -159 338 0 581 57 680 159 29 30 35 43 35 80 0 37 -6 50 -35 80 -47 48 -123 84 -246 115 l-103 26 51 59 c159 187 253 364 305 575 33 134 38 328 10 430 -39 146 -136 300 -245 385 -67 54 -195 120 -272 140 -56 16 -228 28 -265 19z m239 -84 c119 -30 209 -82 302 -175 129 -127 183 -250 191 -435 12 -266 -85 -523 -295 -783 -52 -64 -258 -249 -323 -291 -29 -18 -29 -18 -67 10 -176 131 -306 259 -392 384 -231 337 -283 686 -144 961 49 99 170 220 271 272 145 76 307 96 457 57z m-367 -1631 c81 -71 199 -159 214 -159 15 0 94 56 190 137 89 73 93 74 231 39 146 -37 228 -85 228 -133 0 -51 -140 -114 -332 -150 -131 -25 -504 -25 -634 0 -197 36 -334 98 -334 150 0 56 103 108 288 147 48 10 88 19 89 19 1 1 28 -22 60 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1959 c-221 -43 -381 -288 -342 -521 34 -200 177 -348 366 -381 288 -49 549 226 498 526 -45 261 -272 425 -522 376z m243 -97 c77 -38 148 -111 185 -190 24 -50 27 -69 27 -162 0 -93 -3 -112 -27 -162 -37 -80 -107 -152 -187 -191 -58 -28 -75 -32 -151 -32 -71 0 -94 4 -142 27 -80 37 -152 107 -191 187 -30 61 -32 72 -32 171 0 93 3 112 27 162 91 196 309 280 491 190z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8901bbd3111d979b5df4ed6ec0ba67a5.svg";
export { ForwardRef as ReactComponent };